import { FileIcon, ReloadIcon } from "@radix-ui/react-icons";
import PromptButton from "./prompt-button";
import { useEffect, useRef, useState } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import {
    NativeSelect,
    NativeSelectOption,
} from "@/components/ui/native-select";
import { promptsArray } from "./prompts";

interface QuickPromptsProps {
    sendMessage: (content: string) => void;
}

export default function QuickPrompts({ sendMessage }: QuickPromptsProps) {
    const [currentPrompts, setCurrentPrompts] = useState<string[]>([]);
    const promptsRef = useRef<HTMLDivElement>(null);
    const currentIndexRef = useRef(0);

    const refreshPrompts = () => {
        const start = currentIndexRef.current;
        const nextIndex = start + 6;
        setCurrentPrompts(promptsArray.slice(start, nextIndex));

        if (nextIndex >= promptsArray.length) {
            currentIndexRef.current = 0;
        } else {
            currentIndexRef.current = nextIndex;
        }
    };

    function messageSelect(prompt: string) {
        sendMessage(prompt);
    }

    useEffect(() => {
        // Use setTimeout to avoid synchronous state update warning and ensure client-side execution
        const timer = setTimeout(() => {
            refreshPrompts();
        }, 0);
        return () => clearTimeout(timer);
    }, []);

    useGSAP(() => {
        if (currentPrompts.length > 0) {
            gsap.fromTo('.prompt-btn',
                { opacity: 0, scale: 0.9 },
                {
                    opacity: 1,
                    scale: 1,
                    duration: 0.3,
                    stagger: 0.1,
                    ease: "back.out(1.7)"
                }
            );
        }
    }, { scope: promptsRef, dependencies: [currentPrompts] });

    return (
        <div ref={promptsRef} className="relative max-w-4xl min-w-[320px] z-100">

            <div className="hidden md:block">
                <div className="flex flex-wrap gap-2 mb-4 px-6">
                    {currentPrompts.map((prompt, index) => {
                        if (prompt !== "-") {
                            return <div key={index} onClick={() => sendMessage(prompt)}>
                                <PromptButton>{prompt}</PromptButton>
                            </div>;
                        }
                    })}
                </div>
                <div
                    id="more-prompts"
                    className="flex justify-end px-12 text-sm items-center gap-2 text-muted-foreground cursor-pointer hover:text-foreground"
                    onClick={refreshPrompts}
                >

                    <ReloadIcon /> More prompts
                </div>

            </div>

            <div className="mt-4 block md:hidden">
                <NativeSelect defaultValue="" onChange={(event) => messageSelect(event.currentTarget.value)}>
                    <NativeSelectOption value="" disabled>
                        ...or choose a prompt
                    </NativeSelectOption>
                    {promptsArray.map((prompt, index) => (
                        <NativeSelectOption key={index} value={prompt}>
                            {prompt}
                        </NativeSelectOption>
                    ))}
                </NativeSelect>
            </div>

        </div>
    );
}


